import { NavLink } from 'react-router-dom';
import Logo from '../../assets/img/Logo-black.png';
import FooterImg from '../../assets/img/footer-img.png';
import './Footer.scss';
import navLinks from '../Navbar/NavLinks';

const Footer = () => {
    return (
        <div className="Footer bg-light">
            <div className="container">
                <div className="row justify-content-between my-3">
                    <div className="col-md-4 py-5">
                        <img className="footer-logo" src={Logo} alt="Land of game"/>
                        <p className="lead">Land of game is a game database that built using React and RAWG API.</p>
                    </div>
                    <div className="col-md-2 py-2 py-md-5">
                        <h3 className="footer-link-title">Sitemaps</h3>
                        <ul className="navbar-nav">
                            {navLinks.map((navlink, index) => {
                                return(
                                    <li className="nav-item" key={index}>
                                        <NavLink className="card-link" to={navlink.link}>{navlink.name}</NavLink>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                    <div className="col-md-2 py-2 py-md-5">
                        <h3 className="footer-link-title">Credits</h3>
                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <NavLink className="card-link" to="/">RAWG API</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="card-link" to="/">Undraw</NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-3 d-none d-md-block">
                        <img style={{ opacity: (0.3), width: 'auto', height: 300 }} src={FooterImg} alt="Gaming mouse"/>
                    </div>
                </div>
            </div>
            <div className="footer-copyright">
                <div className="container">
                    <div className="row justify-content-between">
                        <div className="col-md-9">
                            <p className="lead">
                                <small>&copy; 2021 - Land of Game. All rights reserved. Developed by <a style={{color: '#fff', textDecoration: 'none'}} href="https://novanjunaedi.com" target="_blank" rel="noreferrer">Novan Junaedi</a>.</small>
                            </p>
                        </div>
                        <div className="col-md-3">
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
